// @ts-nocheck
import { getOldCoverImageUrl } from '../../../../../utils/getCoverImageUrl';
import { formatDateWithAddedDaysUTC } from '../../../../../utils/dateUtility';
import { useTranslation } from 'react-i18next';
import { CalendarTodayOutlined } from '@mui/icons-material';
import './CoverPage.css';

const CoverPage = ({ trip, tenant, tenantSettings }) => {
  const heroImage = trip?.tripimage?.[0];
  const logoUrl = tenant?.tenantlogo;
  const duration = trip?.tripdays?.length ?? 0;
  const { bodyfont } = tenantSettings;
  const { i18n } = useTranslation(['trip', 'common']);
  const locale = i18n.language;

  const dateRange = formatDateWithAddedDaysUTC(
    trip.startdate,
    trip.duration - 1, // Make sure to reduce by one since duration is number of DAYS, not nights.
    locale
  );

  return (
    <div className='travel-doc__cover' style={{ fontFamily: bodyfont }}>
      {/* Hero image — top 6.5" */}
      <div
        className={`travel-doc__cover-hero${!heroImage?.imageurl ? ' travel-doc__cover-hero--no-image' : ''}`}
      >
        {heroImage?.imageurl ? (
          <img
            src={getOldCoverImageUrl(heroImage?.imageurl, 'LG')}
            alt={trip?.tripname || 'Trip cover'}
            className='travel-doc__cover-hero-img'
          />
        ) : null}

        {/* Operator logo badge — top left of hero */}
        {logoUrl && (
          <div className='travel-doc__cover-logo-badge'>
            <img src={logoUrl} alt={tenant?.tenantname || 'Operator'} />
          </div>
        )}
      </div>

      {/* Title block — bottom ~4.5" */}
      <div className='travel-doc__cover-title-block'>
        {duration > 0 && (
          <p className='travel-doc__cover-eyebrow'>{duration} Day Itinerary</p>
        )}
        <h1 className='travel-doc__cover-trip-title'>{trip?.tripname}</h1>
        {trip?.passengername && (
          <p className='travel-doc__cover-prepared-for'>
            Prepared for {trip.passengername}
          </p>
        )}
        <div className='travel-doc__cover-dates-container'>
          <CalendarTodayOutlined
            className='header__date-icon'
            style={{ width: '14px' }}
          />
          <p
            className='travel-doc__cover__date-text'
            style={{ fontFamily: tenantSettings?.headingfont }}
          >
            {dateRange && (
              <p className='travel-doc__cover-dates'>{dateRange}</p>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CoverPage;
